import React, { Component } from 'react'
import Menu from '../Menu'
import styles from './Tour.css'
import Gallery from './Gallery'

export default class Tour extends Component {
  handleTourWorkClick = (i) => {
    this.props.history.push('/tour/work/'+(i+1))
  }
  render () {
    return (
      <div>
        <Menu logo={this.props.logo} menu={this.props.menu}>Select A Work</Menu>
        <div className={styles.main}>
          <Gallery items={this.props.items} handleImageClick={this.handleTourWorkClick}/>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Rist/modules/Tour/index.js